import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumbersGridComponent } from './numbers-grid.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [NumbersGridComponent],
  exports: [NumbersGridComponent]
})
export class NumbersGridModule {
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/numbers-grid/numbers-grid.module.ts